export type FieldNames =
  | 'scheme.header.headerColor'
  | 'scheme.header.headerTitleColor'
  | 'scheme.header.headerSubtitleColor'
  | 'scheme.header.windowColor'
  | 'scheme.header.messageBarColor'
  | 'scheme.header.messageBarTextColor'
  | 'scheme.message.messageBubbleColor'
  | 'scheme.message.messageBubbleTextColor'
  | 'scheme.message.personalMessageBubbleColor'
  | 'scheme.message.personalMessageBubbleTextColor'
  | 'scheme.message.buttonEdgeColor'
  | 'scheme.message.buttonTextColor'
  | 'scheme.message.buttonHoverColor'
  | 'scheme.message.buttonBackgroundColor'
  | 'scheme.message.carouselBackgroundColor'
  | 'scheme.message.carouselButtonColor'
  | 'scheme.message.carouselTextColor'
  | 'scheme.message.carouselButtonTextColor'
  | 'scheme.message.submitButtonColor'
  | 'scheme.message.notificationAIGeneratedAnswerTextColor'
  | 'scheme.message.streamingIndicatorColor'
  | 'scheme.message.urlColor'
  | 'scheme.message.urlHoverColor'
  | 'scheme.message.urlClickColor'
  | 'scheme.greeting.titleColor'
  | 'scheme.greeting.subtitleColor'
  | 'scheme.greeting.buttonTextColor'
  | 'scheme.greeting.buttonColor'
  | 'scheme.greeting.backgroundColor';

export interface ColorInputConfig {
  fieldName: FieldNames;
  labelKey: string;
  id: string;
}

export const colorConfigs: Record<string, ColorInputConfig[]> = {
  headerColors: [
    {
      fieldName: 'scheme.header.headerColor',
      labelKey: 'settings.webclient.config.form.config.header-background',
      id: 'headerColor',
    },
    {
      fieldName: 'scheme.header.headerTitleColor',
      labelKey: 'settings.webclient.config.form.config.header-title-color',
      id: 'headerTitleColor',
    },
    {
      fieldName: 'scheme.header.headerSubtitleColor',
      labelKey: 'settings.webclient.config.form.config.header-subtitle-color',
      id: 'headerSubtitleColor',
    },
    {
      fieldName: 'scheme.header.windowColor',
      labelKey: 'settings.webclient.config.form.config.header-window-color',
      id: 'windowColor',
    },
    {
      fieldName: 'scheme.header.messageBarColor',
      labelKey:
        'settings.webclient.config.form.config.header-message-bar-color',
      id: 'messageBarColor',
    },
    {
      fieldName: 'scheme.header.messageBarTextColor',
      labelKey:
        'settings.webclient.config.form.config.header-message-bar-text-color',
      id: 'messageBarTextColor',
    },
  ],

  messageColors: [
    {
      fieldName: 'scheme.message.messageBubbleColor',
      labelKey: 'settings.webclient.config.form.config.bot-bubble-background',
      id: 'messageBubbleColor',
    },
    {
      fieldName: 'scheme.message.messageBubbleTextColor',
      labelKey: 'settings.webclient.config.form.config.bot-bubble-text',
      id: 'messageBubbleTextColor',
    },
    {
      fieldName: 'scheme.message.personalMessageBubbleColor',
      labelKey: 'settings.webclient.config.form.config.user-bubble-background',
      id: 'personalMessageBubbleColor',
    },
    {
      fieldName: 'scheme.message.personalMessageBubbleTextColor',
      labelKey: 'settings.webclient.config.form.config.user-bubble-text',
      id: 'personalMessageBubbleTextColor',
    },
    {
      fieldName: 'scheme.message.buttonEdgeColor',
      labelKey: 'settings.webclient.config.form.config.button-edge',
      id: 'buttonEdgeColor',
    },
    {
      fieldName: 'scheme.message.buttonTextColor',
      labelKey: 'settings.webclient.config.form.config.button-text',
      id: 'buttonTextColor',
    },
    {
      fieldName: 'scheme.message.buttonHoverColor',
      labelKey: 'settings.webclient.config.form.config.button-hover',
      id: 'buttonHoverColor',
    },
    {
      fieldName: 'scheme.message.buttonBackgroundColor',
      labelKey: 'settings.webclient.config.form.config.button-background',
      id: 'buttonBackgroundColor',
    },
    {
      fieldName: 'scheme.message.carouselBackgroundColor',
      labelKey: 'settings.webclient.config.form.config.carousel-background',
      id: 'carouselBackgroundColor',
    },
    {
      fieldName: 'scheme.message.carouselButtonColor',
      labelKey:
        'settings.webclient.config.form.config.carousel-button-background',
      id: 'carouselButtonColor',
    },
    {
      fieldName: 'scheme.message.carouselTextColor',
      labelKey: 'settings.webclient.config.form.config.carousel-text',
      id: 'carouselTextColor',
    },
    {
      fieldName: 'scheme.message.carouselButtonTextColor',
      labelKey: 'settings.webclient.config.form.config.carousel-button-text',
      id: 'carouselButtonTextColor',
    },
    {
      fieldName: 'scheme.message.submitButtonColor',
      labelKey: 'settings.webclient.config.form.config.submit-button',
      id: 'submitButtonColor',
    },
    {
      fieldName: 'scheme.message.notificationAIGeneratedAnswerTextColor',
      labelKey:
        'settings.webclient.config.form.config.ai-generated-answer-text-color',
      id: 'notificationAIGeneratedAnswerTextColor',
    },
    {
      fieldName: 'scheme.message.streamingIndicatorColor',
      labelKey:
        'settings.webclient.config.form.config.streaming-indicator-color',
      id: 'streamingIndicatorColor',
    },
    {
      fieldName: 'scheme.message.urlColor',
      labelKey: 'settings.webclient.config.form.config.url-color',
      id: 'messageUrlColor',
    },
    {
      fieldName: 'scheme.message.urlHoverColor',
      labelKey: 'settings.webclient.config.form.config.url-hover-color',
      id: 'messageUrlHoverColor',
    },
    {
      fieldName: 'scheme.message.urlClickColor',
      labelKey: 'settings.webclient.config.form.config.url-click-color',
      id: 'messageUrlClickColor',
    },
  ],

  greetingColors: [
    {
      fieldName: 'scheme.greeting.titleColor',
      labelKey: 'settings.webclient.config.form.config.greeting-title',
      id: 'greetingTitleColor',
    },
    {
      fieldName: 'scheme.greeting.subtitleColor',
      labelKey: 'settings.webclient.config.form.config.greeting-subtitle',
      id: 'greetingSubtitleColor',
    },
    {
      fieldName: 'scheme.greeting.buttonTextColor',
      labelKey: 'settings.webclient.config.form.config.greeting-button-text',
      id: 'greetingButtonTextColor',
    },
    {
      fieldName: 'scheme.greeting.buttonColor',
      labelKey:
        'settings.webclient.config.form.config.greeting-button-background',
      id: 'greetingButtonColor',
    },
    {
      fieldName: 'scheme.greeting.backgroundColor',
      labelKey: 'settings.webclient.config.form.config.greeting-background',
      id: 'greetingBackgroundColor',
    },
  ],
};
